import { orchestrator } from 'satcheljs';
import {
    setFolderPermissionsLoader,
    folderPermissionsDialogOkClick,
} from '../actions/internalActions';
import { lazyUpdateFolderPermissions } from 'owa-folders';
import { getStore } from '../store/store';

/**
 * This orchestrator listens to action fired on user clicking 'Ok' button in folder permissions dialog.
 * It will fire actions to show loader and to update folder permissions on server.
 */
export const folderPermissionsDialogOkClickOrchestrator = orchestrator(
    folderPermissionsDialogOkClick,
    async () => {
        const { folderId, permissions } = getStore();
        setFolderPermissionsLoader(true);

        const updateFolderPermissions = await lazyUpdateFolderPermissions.import();
        updateFolderPermissions(folderId, permissions);
    }
);
